import React from 'react';
import ErrorBoundary from '../../components/ErrorBoundary';

// Reference number and free-text notes for the add/edit transaction form.
export default function TransactionNoteFields({ transaction }) {
  return (
    <ErrorBoundary>
      <div>
        <label className="block text-sm font-medium mb-1">
          Reference Number<span className="text-gray-500 text-xs ml-1">(Optional)</span>
        </label>
        <input
          type="text"
          name="reference_number"
          defaultValue={transaction?.reference_number || ''}
          placeholder="e.g., Check #1234, Conf #ABC123"
          className="w-full border rounded px-3 py-2"
        />
        <p className="text-xs text-gray-500 mt-1">Bank transaction reference, check number, or confirmation code</p>
      </div>
      <div>
        <label className="block text-sm font-medium mb-1">
          Notes<span className="text-gray-500 text-xs ml-1">(Optional)</span>
        </label>
        <textarea
          name="notes"
          rows={3}
          maxLength={2000}
          defaultValue={transaction?.notes || ''}
          className="w-full border rounded px-3 py-2"
        />
      </div>
    </ErrorBoundary>
  );
}
